import { render, staticRenderFns } from "./EnAddData.vue?vue&type=template&id=5a271c82&scoped=true"
import script from "./EnAddData.vue?vue&type=script&lang=js"
export * from "./EnAddData.vue?vue&type=script&lang=js"
import style0 from "./EnAddData.vue?vue&type=style&index=0&id=5a271c82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a271c82",
  null
  
)

export default component.exports